import { render, staticRenderFns } from "./DocumentHistory.vue?vue&type=template&id=4548b831&scoped=true"
import script from "./DocumentHistory.vue?vue&type=script&lang=js"
export * from "./DocumentHistory.vue?vue&type=script&lang=js"
import style0 from "./DocumentHistory.vue?vue&type=style&index=0&id=4548b831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4548b831",
  null
  
)

export default component.exports